// Module assignment shortcuts are stored as a short string on the module:
// 'planner' for the plan builder, 'content-type:<id>' for a content library's
// create page. Both the builder and the learner player read them from here.
const CONTENT_TYPE_PREFIX = 'content-type:';

export const contentTypeShortcut = (contentTypeId: number) =>
  `${CONTENT_TYPE_PREFIX}${contentTypeId}`;

// Library names are usually plural ("Drills"); the builder reads singular
// ("Drill builder").
export const builderLabel = (libraryName: string) => {
  const name = libraryName.trim();
  const singular = /[^s]s$/i.test(name) ? name.slice(0, -1) : name;
  return `${singular} builder`;
};

export interface ResolvedShortcut {
  to: string;
  label: string;
}

export function resolveShortcut(
  shortcut: string,
  workspaceId: string,
  contentTypes: { id: number; name: string }[],
): ResolvedShortcut | null {
  if (shortcut === 'planner') {
    return { to: `/${workspaceId}/planner`, label: 'Build a practice plan' };
  }
  if (shortcut.startsWith(CONTENT_TYPE_PREFIX)) {
    const id = Number(shortcut.slice(CONTENT_TYPE_PREFIX.length));
    const type = contentTypes.find((ct) => ct.id === id);
    if (!type) return null;
    return {
      to: `/${workspaceId}/content-types/${id}/contents/create`,
      label: `Open ${builderLabel(type.name).toLowerCase()}`,
    };
  }
  return null;
}
